var styles = {"box":"Accordion_box_1kgdn_1","button":"Accordion_button_1kgdn_8","panel":"Accordion_panel_1kgdn_30","icon":"Accordion_icon_1kgdn_42","open":"Accordion_open_1kgdn_47","text-white":"Accordion_text-white_1kgdn_50","small-gap":"Accordion_small-gap_1kgdn_53","mobile-small-padding":"Accordion_mobile-small-padding_1kgdn_61"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
